import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-section-title',
  templateUrl: './edit-section-title.component.html',
  styleUrls: ['./edit-section-title.component.scss']
})
export class EditSectionTitleComponent implements OnInit, AfterViewInit {
  @Input() sectionInfo: any;
  titleForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  ngAfterViewInit(): void {
    this.updateForm();
  }


  sendData(): any {
    const dataToSend = {
      ...this.titleForm.value,
      id: this.sectionInfo.id
    };

    this.activeModal.close(dataToSend);
  }

  private createForm(): any {
    this.titleForm = this.fb.group({
      name: ['', Validators.required]
    });
  }

  private updateForm(): any {
    this.titleForm.get('name').setValue(this.sectionInfo.name);
  }

}
